import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'

interface Option {
  value: string
  label: string
  children?: Option[]
}
interface PropsType {
  options: Option[]
  value: string[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    options: null,
    value: null
  },
  emits: ['onChange'],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  options: Option[]
  value: string[]
}




const selectV = ref<(string | number)[]>(props.value)

const displayRender = ({ labels }: { labels: string[] }) => {
  return labels[labels.length - 1]
}

const handleChange = () => {
  emits('onChange', selectV.value)
}

const handlePopupVisibleChange = (visible: boolean) => {
  if (visible) {
    setTimeout(() => {
      // 找出所有渲染出来的 menu item DOM，手动加 id
      addIdsToCascaderMenus()
      observeCascaderChanges() // 观察后续子菜单的出现
    }, 100) // 等待 DOM 渲染完成
  }
}

const addIdsToCascaderMenus = () => {
  const menus = document.querySelectorAll('.ant-cascader-menu') // 每一级菜单
  menus.forEach((menu, levelIndex) => {
    const items = menu.querySelectorAll('.ant-cascader-menu-item')
    items.forEach((item, itemIndex) => {
      item.setAttribute('id', `cascader_option_${levelIndex}_${itemIndex}`)
    })
  })
}

const observeCascaderChanges = () => {
  const container = document.querySelector('.ant-cascader-menus')

  if (!container) return

  const observer = new MutationObserver(() => {
    addIdsToCascaderMenus()
  })

  observer.observe(container, {
    childList: true,
    subtree: true,
  })
}

return { __sfc: true,props, emits, selectV, displayRender, handleChange, handlePopupVisibleChange, addIdsToCascaderMenus, observeCascaderChanges }
}

})